"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScreenshotUrl = void 0;
const getScreenshotUrl = (baseScreenshotURL, screenshotId) => baseScreenshotURL && screenshotId
    ? `${baseScreenshotURL}/api/screenshots/${screenshotId}`
    : null;
exports.getScreenshotUrl = getScreenshotUrl;
//# sourceMappingURL=get-screenshot-url.js.map